import { render, staticRenderFns } from "./dire-detail.vue?vue&type=template&id=0070e651&"
import script from "./dire-detail.vue?vue&type=script&lang=js&"
export * from "./dire-detail.vue?vue&type=script&lang=js&"
import style0 from "./dire-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports